// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"403":"locale-hi","543":"locale-ta","723":"locale-te"}[chunkId] || chunkId) + "." + {"403":"ca90c3ab","453":"deb86c0d","455":"269184ee","543":"a218dfcb","723":"badce78e","977":"304c1de4"}[chunkId] + ".chunk.js";
};